import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  return <section id="testimonios" className="relative z-10 py-8 md:py-10 px-4 cosmic-bg" data-id="element-322">
      <div className="max-w-6xl mx-auto" data-id="element-323">
        {/* Section Header */}
        <div className="text-center mb-8" data-id="element-324">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3" data-id="element-325">
            Lo que dicen las{' '}
            <span className="text-gold-gradient" data-id="element-326">astrólogas</span>
          </h2>
          <p className="text-lg text-white/80" data-id="element-327">
            Profesionales que ya transformaron su práctica
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-328">
          {/* Testimonial 1 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-5" data-id="element-329">
            <div className="flex items-center gap-1 mb-3" data-id="element-330">
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-331" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-332" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-333" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-334" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-335" />
            </div>
            <QuoteIcon className="w-6 h-6 text-[#F5C842]/30 mb-2" data-id="element-336" />
            <p className="text-white/90 mb-4 leading-relaxed text-sm" data-id="element-337">
              "Antes me tomaba casi 4 horas armar un informe completo. Ahora lo
              hago en menos de la mitad del tiempo y mis clientas me dicen que
              se ven mucho más profesionales. ¡No puedo creer que no lo haya
              encontrado antes!"
            </p>
            <div data-id="element-338">
              <p className="text-white font-semibold text-sm" data-id="element-339">
                María Laura Gómez
              </p>
              <p className="text-white/60 text-xs" data-id="element-340">
                Astróloga • Buenos Aires, 38 años
              </p>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-5" data-id="element-341">
            <div className="flex items-center gap-1 mb-3" data-id="element-342">
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-343" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-344" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-345" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-346" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-347" />
            </div>
            <QuoteIcon className="w-6 h-6 text-[#F5C842]/30 mb-2" data-id="element-348" />
            <p className="text-white/90 mb-4 leading-relaxed text-sm" data-id="element-349">
              "Estaba agotada de trabajar tanto y ganar lo mismo. Con el sistema
              pude subir mis precios porque ahora mis entregas tienen otro
              nivel. Mis clientas notan la diferencia y me recomiendan más."
            </p>
            <div data-id="element-350">
              <p className="text-white font-semibold text-sm" data-id="element-351">
                Carolina Fernández
              </p>
              <p className="text-white/60 text-xs" data-id="element-352">
                Astróloga • Córdoba, 42 años
              </p>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-5" data-id="element-353">
            <div className="flex items-center gap-1 mb-3" data-id="element-354">
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-355" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-356" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-357" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-358" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-359" />
            </div>
            <QuoteIcon className="w-6 h-6 text-[#F5C842]/30 mb-2" data-id="element-360" />
            <p className="text-white/90 mb-4 leading-relaxed text-sm" data-id="element-361">
              "Lo que más me gustó es que no perdí mi esencia. Los informes
              siguen siendo míos, pero ahora están organizados y se ven
              increíbles. Recuperé tiempo para mi familia y para seguir
              estudiando."
            </p>
            <div data-id="element-362">
              <p className="text-white font-semibold text-sm" data-id="element-363">
                Valentina Aguirre
              </p>
              <p className="text-white/60 text-xs" data-id="element-364">
                Astróloga • Mendoza, 35 años
              </p>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-5" data-id="element-365">
            <div className="flex items-center gap-1 mb-3" data-id="element-366">
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-367" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-368" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-369" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-370" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-371" />
            </div>
            <QuoteIcon className="w-6 h-6 text-[#F5C842]/30 mb-2" data-id="element-372" />
            <p className="text-white/90 mb-4 leading-relaxed text-sm" data-id="element-373">
              "Tenía miedo de que fuera algo muy técnico o difícil de usar. Pero
              es súper intuitivo. En una semana ya estaba entregando informes
              con el nuevo formato y mis clientas quedaron encantadas."
            </p>
            <div data-id="element-374">
              <p className="text-white font-semibold text-sm" data-id="element-375">
                Sofía Rodríguez
              </p>
              <p className="text-white/60 text-xs" data-id="element-376">
                Astróloga • Rosario, 29 años
              </p>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-[#1a1030] border border-[#F5C842]/20 rounded-xl p-5 md:col-span-2 lg:col-span-1" data-id="element-377">
            <div className="flex items-center gap-1 mb-3" data-id="element-378">
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-379" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-380" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-381" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-382" />
              <StarIcon className="w-4 h-4 text-[#F5C842] fill-[#F5C842]" data-id="element-383" />
            </div>
            <QuoteIcon className="w-6 h-6 text-[#F5C842]/30 mb-2" data-id="element-384" />
            <p className="text-white/90 mb-4 leading-relaxed text-sm" data-id="element-385">
              "Llevo 15 años haciendo cartas y nunca había encontrado algo así.
              Me ayudó a profesionalizar mi trabajo sin perder la calidez que
              mis clientas valoran. Ahora puedo atender más consultas sin
              sentirme abrumada."
            </p>
            <div data-id="element-386">
              <p className="text-white font-semibold text-sm" data-id="element-387">
                Ana María Peralta
              </p>
              <p className="text-white/60 text-xs" data-id="element-388">
                Astróloga • Mar del Plata, 52 años
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}